const lastSearchLocalStorageKey = '@smiles/flight-search-last-search';
const lastSearchLocalStorageKeyLegacy = 'saveSearchOnStorage';
const lastOriginsLocalStorageKey = '@smiles/flight-search-last-origins';
const lastDestinationsLocalStorageKey =
  '@smiles/flight-search-last-destinations';
const allAirports = 'Todos os Aeroportos';
const exploreWorldItem = {
  name: 'Explorar o mundo',
  city: '',
  code: '',
  country: '',
  iconName: 'travel_explore',
  title: 'Explorar o mundo',
  subtitle: ' ',
  cornerText: '',
};

export {
  exploreWorldItem,
  lastSearchLocalStorageKey,
  lastOriginsLocalStorageKey,
  lastDestinationsLocalStorageKey,
  lastSearchLocalStorageKeyLegacy,
  allAirports,
};
